"use strict";
/* eslint @typescript-eslint/no-explicit-any: 0 */
/* eslint @typescript-eslint/consistent-type-assertions: 0 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockDifferentChainflexLeitungJsons = void 0;
const ArticleSpecs_1 = require("../ArticleSpecs");
const LeitungCategory_1 = require("./LeitungCategory");
exports.mockDifferentChainflexLeitungJsons = [
    {
        Id: 9216319801,
        ArtNr: {
            DE: 'CFLG.4LB.50/125',
            US: 'CFLG-4LB-50/125',
        },
        BestTyp: 210,
        Bezeichnung: {
            'da-DK': 'chainflex® CFLG.4LB TPE-lyslederkabel, 5 x d',
            'de-DE': 'chainflex®Lichtwellenleiter TPE | 4x50/125 ',
            'en-GB': 'chainflex® CFLG.4LB fibre optic cable TPE, 5 x d',
            'en-US': 'chainflex® CFLG-4LB fibre optic cable TPE, 5 x d',
            'es-ES': 'chainflex® cable de fibra óptica | TPE | Ø 9 mm | 50/125 | Radio en cadena: 45 mm (Torsión: ±0º/m)',
            'fr-FR': 'chainflex® cable de fibra óptica | TPE | Ø 9 mm | 50/125 | Radio en cadena: 45 mm (Torsión: ±0º/m)',
            'hu-HU': 'chainflex® CFLG.4LB optikai kábel, TPE, 5 x d',
            'it-IT': 'Cavo ottico chainflex® CFLG.4LB in TPE, 5 x d',
            'ja-JP': 'チェーンフレックスCFLG.4LB 光ファイバーケーブルTPE外被、5 x ケーブル外径',
            'ko-KR': 'chainflex® CFLG.4LB 광섬유 케이블 TPE, 5 x d',
            'nl-NL': 'chainflex® CFLG.4LB TPE glasvezelkabel 5 x d',
            'pl-PL': 'Przewód światłowodowy chainflex® CFLG.4LB TPE, 5 x średnica',
            'pt-BR': 'Cabo de fibra ótica chainflex® CFLG.4LB em TPE, 5 x d',
            'pt-PT': 'Cabo de fibra ótica chainflex® CFLG.4LB em TPE, 5 x d',
            'sv-SE': 'chainflex® CFLG.4LB fiberkabel TPE, 5 x d',
            'zh-CN': 'chainflex® CFLG.4LB高柔性光纤电缆TPE，弯曲半径为5 x d',
            'zh-TW': 'chainflex® CFLG.4LB高柔性光纖電纜TPE,彎曲半徑為5 x d',
        },
        Aussendurchmesser: {
            Value: 9,
            Unit: 'mm',
        },
        BiegeradiusMin: {
            Value: 45,
            Unit: 'mm',
        },
        GewichtKgProKm: {
            Value: 64,
            Unit: 'kg_km',
        },
        RAL_Nummer: '9005',
        Categories: [LeitungCategory_1.LeitungCategory.FibreOpticCables],
        MainCategory: LeitungCategory_1.LeitungCategory.FibreOpticCables,
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
        FreitragenderBetriebErlaubt: true,
        AuhiFreitragendA: {
            Value: 20,
            Unit: 'm_s2',
        },
        AuhiFreitragendV: {
            Value: 10,
            Unit: 'm_s',
        },
        VerfahrwegFreitragendMax: {
            Value: 100,
            Unit: 'm',
        },
        AuhiGleitend: true,
        AuhiGleitendA: {
            Value: 20,
            Unit: 'm_s2',
        },
        AuhiGleitendV: {
            Value: 6,
            Unit: 'm_s',
        },
        VerfahrwegGleitendMax: {
            Value: 100,
            Unit: 'm',
        },
        HaengenderBetriebErlaubt: true,
        BeschleunigungHaengendMax: {
            Value: 20,
            Unit: 'm_s2',
        },
        GeschwindigkeitHaengendMax: {
            Value: 6,
            Unit: 'm_s',
        },
        VerfahrwegHaengendMax: {
            Value: 100,
            Unit: 'm',
        },
        UL_CSA: false,
        DNV_GL: false,
        Reinraum: true,
        Halogenfrei: true,
        EAC: false,
        DESINA: false,
        Flammwidrig: false,
        Kuehlmittelbestaendig: false,
        MUDBestaendig: false,
        Gesamtschirm: true,
        Schirmung: false,
        Ungeschirmt: false,
        Torsionsfaehig: false,
        Mantelwerkstoff: 'TPE',
        Oelbestaendigkeit: 'Class 4',
        UVBestaendigkeit: 'Hoch',
        MinBiegeradiusFaktor: {
            Value: 5,
            Unit: 'x d',
        },
        AuhiTemperaturMax: {
            Value: 80,
            Unit: '°C',
        },
        AuhiTemperaturMin: {
            Value: -35,
            Unit: '°C',
        },
        TwistedPair: false,
        HatStecker: false,
        FesteLaenge: false,
        DataSource: 'akeneo',
        Aderzahl: '4',
        Querschnitt: {
            'bg-BG': '50/125',
            'cs-CZ': '50/125',
            'da-DK': '50/125',
            'de-DE': '50/125',
            'en-GB': '50/125',
            'en-US': '50/125',
            'es-ES': '50/125',
            'fr-FR': '50/125',
            'hu-HU': '50/125',
            'it-IT': '50/125',
            'ja-JP': '50/125',
            'ko-KR': '50/125',
            'nl-NL': '50/125',
            'pl-PL': '50/125',
            'pt-BR': '50/125',
            'pt-PT': '50/125',
            'ru-RU': '50/125',
            'sv-SE': '50/125',
            'tr-TR': '50/125',
            'zh-CN': '50/125',
            'zh-TW': '50/125',
        },
        ArticleType: 'leitung',
    },
    {
        Id: 9007747217,
        ArtNr: {
            DE: 'CF211.02.05.02',
            US: 'CF211-02-05-02',
        },
        BestTyp: 210,
        Bezeichnung: {
            'da-DK': 'PVC datakabel chainflex® CF211',
            'de-DE': 'Chainflex®Datenleitung PVC | (5x(2x0,25))C ',
            'en-GB': 'chainflex® CF211 data cable PVC',
            'en-US': 'chainflex® CF211 data cable PVC',
            'es-ES': 'chainflex® cable de datos | PVC - Aceite | Ø 8,5 mm | (5x(2x0,25))C | Radio en cadena: 64 mm (Torsión: ±30º/m)',
            'fr-FR': 'chainflex® cable de datos | PVC - Aceite | Ø 8,5 mm | (5x(2x0,25))C | Radio en cadena: 64 mm (Torsión: ±30º/m)',
            'hu-HU': 'chainflex® CF211 PVC adatkábel',
            'it-IT': 'chainflex® CF211 cavo per trasmissione dati PVC',
            'ja-JP': 'チェーンフレックスCF211 シールド付きケーブル PVC外被',
            'ko-KR': 'chainflex® CF211 데이터 케이블 PVC',
            'nl-NL': 'chainflex® CF211 PVC datakabel',
            'pl-PL': 'chainflex® CF211 przewody do transmisji danych PVC',
            'pt-BR': 'chainflex® CF211 - Cabo de dados em PVC',
            'pt-PT': 'chainflex® CF211 - Cabo de dados em PVC',
            'sv-SE': 'chainflex® CF211 PVC-datakabel',
            'zh-CN': 'chainflex® CF211高柔性数据电缆PVC',
            'zh-TW': 'chainflex® CF211高柔性數據電纜PVC',
        },
        Aussendurchmesser: {
            Value: 8.5,
            Unit: 'mm',
        },
        BiegeradiusMin: {
            Value: 63.75,
            Unit: 'mm',
        },
        GewichtKgProKm: {
            Value: 92,
            Unit: 'kg_km',
        },
        RAL_Nummer: '7001',
        FreitragenderBetriebErlaubt: true,
        AuhiFreitragendA: {
            Value: 50,
            Unit: 'm_s2',
        },
        AuhiFreitragendV: {
            Value: 5,
            Unit: 'm_s',
        },
        VerfahrwegFreitragendMax: {
            Value: 100,
            Unit: 'm',
        },
        AuhiGleitend: true,
        AuhiGleitendA: {
            Value: 50,
            Unit: 'm_s2',
        },
        AuhiGleitendV: {
            Value: 3,
            Unit: 'm_s',
        },
        VerfahrwegGleitendMax: {
            Value: 100,
            Unit: 'm',
        },
        HaengenderBetriebErlaubt: true,
        BeschleunigungHaengendMax: {
            Value: 50,
            Unit: 'm_s2',
        },
        GeschwindigkeitHaengendMax: {
            Value: 3,
            Unit: 'm_s',
        },
        VerfahrwegHaengendMax: {
            Value: 100,
            Unit: 'm',
        },
        UL_CSA: true,
        DNV_GL: false,
        Reinraum: true,
        Halogenfrei: false,
        EAC: true,
        DESINA: false,
        Flammwidrig: true,
        Kuehlmittelbestaendig: false,
        MUDBestaendig: false,
        Gesamtschirm: false,
        Schirmung: true,
        Ungeschirmt: false,
        Torsionsfaehig: false,
        Mantelwerkstoff: 'PVC',
        Oelbestaendigkeit: 'Class 2',
        UVBestaendigkeit: 'Mittel',
        MinBiegeradiusFaktor: {
            Value: 7.5,
            Unit: 'x d',
        },
        AuhiTemperaturMax: {
            Value: 70,
            Unit: '°C',
        },
        AuhiTemperaturMin: {
            Value: 5,
            Unit: '°C',
        },
        Aderzahl: '5x2',
        TwistedPair: true,
        AderzahlBerechnet: 10,
        Querschnitt: {
            'bg-BG': '0,25',
            'cs-CZ': '0,25',
            'da-DK': '0,25',
            'de-DE': '0,25',
            'en-GB': '0.25',
            'en-US': '0.25',
            'es-ES': '0,25',
            'fr-FR': '0,25',
            'hu-HU': '0,25',
            'it-IT': '0,25',
            'ja-JP': '0.25',
            'ko-KR': '0.25',
            'nl-NL': '0,25',
            'pl-PL': '0,25',
            'pt-BR': '0,25',
            'pt-PT': '0,25',
            'ru-RU': '0,25',
            'sv-SE': '0,25',
            'tr-TR': '0,25',
            'zh-CN': '0.25',
            'zh-TW': '0.25',
        },
        Kupferzahl: {
            Value: 52,
            Unit: 'kg_km',
        },
        Leitungsaufbau: {
            'bg-BG': '(5x(2x0,25))C',
            'cs-CZ': '(5x(2x0,25))C',
            'da-DK': '(5x(2x0,25))C',
            'de-DE': '(5x(2x0,25))C',
            'en-GB': '(5x(2x0.25))C',
            'en-US': '5 PR 24 AWG (0.25)',
            'es-ES': '(5x(2x0,25))C',
            'fr-FR': '(5x(2x0,25))C',
            'hu-HU': '(5x(2x0,25))C',
            'it-IT': '(5x(2x0,25))C',
            'ja-JP': '(5x(2x0.25))C',
            'ko-KR': '(5x(2x0.25))C',
            'nl-NL': '(5x(2x0,25))C',
            'pl-PL': '(5x(2x0,25))C',
            'pt-BR': '(5x(2x0,25))C',
            'pt-PT': '(5x(2x0,25))C',
            'ru-RU': '(5x(2x0,25))C',
            'sv-SE': '(5x(2x0,25))C',
            'tr-TR': '(5x(2x0,25))C',
            'zh-CN': '(5x(2x0.25))C',
            'zh-TW': '(5x(2x0.25))C',
        },
        HatStecker: false,
        FesteLaenge: false,
        DataSource: 'akeneo',
        Categories: [LeitungCategory_1.LeitungCategory.DataCables],
        MainCategory: LeitungCategory_1.LeitungCategory.DataCables,
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
        ArticleType: 'leitung',
    },
    {
        Id: 9011874529,
        ArtNr: {
            DE: 'CFBUS.PUR.052',
            US: 'CFBUS-PUR-052',
        },
        BestTyp: 210,
        Bezeichnung: {
            'da-DK': 'chainflex® CFBUS PUR-buskabel, CAT7',
            'de-DE': 'chainflex®Busleitung PUR Ethernet/CAT7 | (4x(2x0,15)C)C ',
            'en-GB': 'chainflex® CFBUS bus cable PUR, CAT7',
            'en-US': 'chainflex® CFBUS bus cable PUR, CAT7',
            'es-ES': 'chainflex® cable de bus | PUR | Ø 9,5 mm | (4x(2x0,15)C)C | Radio en cadena: 119 mm (Torsión: ±30º/m)',
            'fr-FR': 'chainflex® cable de bus | PUR | Ø 9,5 mm | (4x(2x0,15)C)C | Radio en cadena: 119 mm (Torsión: ±30º/m)',
            'hu-HU': 'chainflex® CFBUS buszkábel PUR, CAT7A',
            'it-IT': 'chainflex® cavo bus CFBUS in PUR, CAT7',
            'ja-JP': 'チェーンフレックス CFBUS バスケーブル PUR外被、CAT7',
            'ko-KR': 'chainflex® CFBUS 버스 케이블 PUR, CAT7',
            'nl-NL': 'chainflex® CFBUS PUR buskabel CAT7',
            'pl-PL': 'Przewód magistralowy chainflex® CFBUS PUR, CAT7',
            'pt-BR': 'Cabo bus chainflex® CFBUS em PUR, CAT7',
            'pt-PT': 'Cabo bus chainflex® CFBUS em PUR, CAT7',
            'sv-SE': 'chainflex® CFBUS busskabel PUR, CAT7',
            'zh-CN': 'chainflex® CFBUS PUR高柔性总线电缆，CAT7',
        },
        Aussendurchmesser: {
            Value: 9.5,
            Unit: 'mm',
        },
        Categories: [LeitungCategory_1.LeitungCategory.BusCables],
        MainCategory: LeitungCategory_1.LeitungCategory.BusCables,
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
        BiegeradiusMin: {
            Value: 118.75,
            Unit: 'mm',
        },
        GewichtKgProKm: {
            Value: 129,
            Unit: 'kg_km',
        },
        RAL_Nummer: '4001',
        FreitragenderBetriebErlaubt: true,
        AuhiFreitragendA: {
            Value: 30,
            Unit: 'm_s2',
        },
        AuhiFreitragendV: {
            Value: 3,
            Unit: 'm_s',
        },
        VerfahrwegFreitragendMax: {
            Value: 20,
            Unit: 'm',
        },
        AuhiGleitend: true,
        AuhiGleitendA: {
            Value: 30,
            Unit: 'm_s2',
        },
        AuhiGleitendV: {
            Value: 2,
            Unit: 'm_s',
        },
        VerfahrwegGleitendMax: {
            Value: 20,
            Unit: 'm',
        },
        HaengenderBetriebErlaubt: true,
        BeschleunigungHaengendMax: {
            Value: 30,
            Unit: 'm_s2',
        },
        GeschwindigkeitHaengendMax: {
            Value: 2,
            Unit: 'm_s',
        },
        VerfahrwegHaengendMax: {
            Value: 20,
            Unit: 'm',
        },
        UL_CSA: true,
        DNV_GL: true,
        Reinraum: true,
        Halogenfrei: true,
        EAC: true,
        DESINA: true,
        Flammwidrig: true,
        Kuehlmittelbestaendig: true,
        MUDBestaendig: true,
        BusSystem: { 'de-DE': 'Ethernet/CAT7' },
        Gesamtschirm: false,
        Schirmung: false,
        Ungeschirmt: false,
        Torsionsfaehig: false,
        Mantelwerkstoff: 'PUR',
        Oelbestaendigkeit: 'Class 3',
        UVBestaendigkeit: 'Mittel',
        MinBiegeradiusFaktor: {
            Value: 12.5,
            Unit: 'x d',
        },
        AuhiTemperaturMax: {
            Value: 70,
            Unit: '°C',
        },
        AuhiTemperaturMin: {
            Value: -20,
            Unit: '°C',
        },
        Aderzahl: '4x2',
        TwistedPair: false,
        Querschnitt: {
            'bg-BG': '0,15',
            'cs-CZ': '0,15',
            'da-DK': '0,15',
            'de-DE': '0,15',
            'en-GB': '0.15',
            'en-US': 'AWG26',
            'es-ES': '0,15',
            'fr-FR': '0,15',
            'hu-HU': '0,15',
            'it-IT': '0,15',
            'ja-JP': '0.15',
            'ko-KR': '0.15',
            'nl-NL': '0,15',
            'pl-PL': '0,15',
            'pt-BR': '0,15',
            'pt-PT': '0,15',
            'ru-RU': '0,15',
            'sv-SE': '0,15',
            'tr-TR': '0,15',
            'zh-CN': '0.15',
            'zh-TW': '0.15',
        },
        Kupferzahl: {
            Value: 89,
            Unit: 'kg_km',
        },
        Leitungsaufbau: {
            'bg-BG': '(4x(2x0,15)C)C',
            'cs-CZ': '(4x(2x0,15)C)C',
            'da-DK': '(4x(2x0,15)C)C',
            'de-DE': '(4x(2x0,15)C)C',
            'en-GB': '(4x(2x0.15)C)C',
            'en-US': '4 PR 26 AWG (0.15)',
            'es-ES': '(4x(2x0,15)C)C',
            'fr-FR': '(4x(2x0,15)C)C',
            'hu-HU': '(4x(2x0,15)C)C',
            'it-IT': '(4x(2x0,15)C)C',
            'ja-JP': '(4x(2x0.15)C)C',
            'ko-KR': '(4x(2x0.15)C)C',
            'nl-NL': '(4x(2x0,15)C)C',
            'pl-PL': '(4x(2x0,15)C)C',
            'pt-BR': '(4x(2x0,15)C)C',
            'pt-PT': '(4x(2x0,15)C)C',
            'ru-RU': '(4x(2x0,15)C)C',
            'sv-SE': '(4x(2x0,15)C)C',
            'tr-TR': '(4x(2x0,15)C)C',
            'zh-CN': '(4x(2x0.15)C)C',
            'zh-TW': '(4x(2x0.15)C)C',
        },
        HatStecker: false,
        FesteLaenge: false,
        DataSource: 'akeneo',
        ArticleType: 'leitung',
    },
    {
        Id: 9049865332,
        ArtNr: {
            DE: 'CFROBOT-TEST-5.500',
        },
        BestTyp: 210,
        Aussendurchmesser: {
            Value: 8.5,
            Unit: 'mm',
        },
        BiegeradiusMin: {
            Value: 85,
            Unit: 'mm',
        },
        GewichtKgProKm: {
            Value: 53,
            Unit: 'kg_km',
        },
        RAL_Nummer: '9005',
        Categories: [LeitungCategory_1.LeitungCategory.FibreOpticCables, LeitungCategory_1.LeitungCategory.RobotCables],
        MainCategory: LeitungCategory_1.LeitungCategory.FibreOpticCables,
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.Chainflex],
        FreitragenderBetriebErlaubt: true,
        AuhiFreitragendA: {
            Value: 10,
            Unit: 'm_s2',
        },
        AuhiFreitragendV: {
            Value: 10,
            Unit: 'm_s',
        },
        VerfahrwegFreitragendMax: {
            Value: 60,
            Unit: 'm',
        },
        AuhiGleitend: false,
        HaengenderBetriebErlaubt: false,
        BeschleunigungHaengendMax: {
            Value: 10,
            Unit: 'm_s2',
        },
        GeschwindigkeitHaengendMax: {
            Value: 6,
            Unit: 'm_s',
        },
        UL_CSA: false,
        DNV_GL: false,
        Reinraum: true,
        Halogenfrei: false,
        EAC: false,
        DESINA: false,
        Flammwidrig: false,
        Kuehlmittelbestaendig: false,
        MUDBestaendig: false,
        Gesamtschirm: false,
        Schirmung: false,
        Ungeschirmt: false,
        Torsionswinkel: {
            Value: 180,
            Unit: 'deg_m',
        },
        Torsionsfaehig: true,
        Mantelwerkstoff: 'TPE',
        Oelbestaendigkeit: 'Class 4',
        UVBestaendigkeit: 'Hoch',
        MinBiegeradiusFaktor: {
            Value: 10,
            Unit: 'x d',
        },
        AuhiTemperaturMax: {
            Value: 80,
            Unit: '°C',
        },
        AuhiTemperaturMin: {
            Value: -35,
            Unit: '°C',
        },
        TwistedPair: false,
        Bezeichnung: {
            'de-DE': 'chainflex® tordierbare Lichtwellenleitung CFROBOT5',
            'en-GB': 'chainflex® fibre optic cable CFROBOT5',
            'en-US': 'chainflex® fiber optic cable CFROBOT5',
            'es-ES': 'chainflex® cable de fibra óptica CFROBOT5',
            'fr-FR': 'Câble fibres optiques chainflex® CFROBOT5',
            'it-IT': 'chainflex® cavo in fibra ottica CFROBOT5',
            'ja-JP': 'チェーンフレックス 光ファイバーケーブル CFROBOT5',
            'ko-KR': 'chainflex® 광 섬유 케이블 CFROBOT5',
            'nl-NL': 'chainflex® glasvezelkabel CFROBOT5',
            'pl-PL': 'Przewód światłowodowy chainflex® CFROBOT5',
            'pt-BR': 'Cabo de fibra ótica chainflex® CFROBOT5',
            'pt-PT': 'Cabos de fibra ótica chainflex® CFROBOT5',
            'ru-RU': 'Оптоволоконный специальный кабель CFROBOT5 для использования в гибких кабель-каналах',
            'sv-SE': 'chainflex® fiberkabel CFROBOT5',
            'zh-CN': 'chainflex® 高柔性光纤电缆CFROBOT5',
            'zh-TW': 'chainflex® 耐彎曲光纖電纜CFROBOT5',
        },
        HatStecker: false,
        FesteLaenge: false,
        DataSource: 'akeneo',
        Aderzahl: '2',
        Querschnitt: {
            'bg-BG': '62,5/125',
            'cs-CZ': '62,5/125',
            'da-DK': '62,5/125',
            'de-DE': '62,5/125',
            'en-GB': '62.5/125',
            'en-US': '62.5/125',
            'es-ES': '62,5/125',
            'fr-FR': '62,5/125',
            'hu-HU': '62,5/125',
            'it-IT': '62,5/125',
            'ja-JP': '62.5/125',
            'ko-KR': '62.5/125',
            'nl-NL': '62,5/125',
            'pl-PL': '62,5/125',
            'pt-BR': '62,5/125',
            'pt-PT': '62,5/125',
            'ru-RU': '62,5/125',
            'sv-SE': '62,5/125',
            'tr-TR': '62,5/125',
            'zh-CN': '62.5/125',
            'zh-TW': '62.5/125',
        },
        ArticleType: 'leitung',
    },
];
//# sourceMappingURL=differentChainflexLeitungJsons.js.map